import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import FormInverse from './FormInverse';

const FormInverseContainer = props => (
  <Provider store={store}>
    <FormInverse {...props} />
  </Provider>
);

export default FormInverseContainer;
